export const CURSOR = 3;
export const HOME_BUTTON = 2;
export const INFO = 1;
export const PAGE_CONTENT = 0;
